import { useField, useFormikContext } from 'formik';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import calenderIcon from '../../assets/icons/calendar.svg';
import './DatePicker.scss';
import { useEffect, useState } from 'react';
import { format } from 'date-fns';

const DatePicker = (props: {
	label: string;
	name: string;
	placeholder: string;
	minDate?: Date;
	maxDate?: Date;
	disabled?: boolean;
}) => {
	const { label, name, placeholder, minDate, maxDate, disabled } = props;
	const [field, meta, helpers] = useField(name);
	const [open, setOpen] = useState(false);

	useEffect(() => {
		if (!field?.value) {
			helpers.setValue(format(new Date(), 'MM/dd/yyyy') || null);
		}
	}, []);
	const handleOpen = () => {
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
	};
	const handleChange = (val: Date) => {
		helpers.setValue(format(new Date(val || ''), 'MM/dd/yyyy') || null);
	};
	const onClickOutside = (
		event: React.MouseEvent<HTMLDivElement, MouseEvent>,
	) => {
		if (!field?.value) {
			helpers.setTouched(true);
		}
	};

	return (
		<label className="flex flex-col">
			<p className="font-semibold text-base text-rcrm-title">{label}</p>

			<ReactDatePicker
				{...field}
				selected={field.value}
				dateFormat={'MM/dd/yyyy'}
				open={open}
				disabled={disabled}
				shouldCloseOnSelect={false}
				onClickOutside={onClickOutside}
				onKeyDown={(e) => e.preventDefault()}
				onCalendarOpen={() => handleOpen()}
				onCalendarClose={() => handleClose()}
				minDate={minDate}
				maxDate={maxDate}
				calendarClassName="min-w-[200px] max-w-[400px]"
				className={`w-full p-3 rounded-lg text-sm outline-none border-2 ${meta.touched && meta.error ? 'border-rcrm-error' : 'border-rcrm-primary-border-blue'} `}
				showIcon
				closeOnScroll
				icon={<img src={calenderIcon} alt="calender" />}
				calendarIconClassname="right-[12px] top-1/2 -translate-y-1/2"
				placeholderText={placeholder}
				onChange={handleChange}
				value={format(new Date(field.value), 'MM/dd/yyyy')}
			/>
			{meta.touched && meta.error ? (
				<div className="text-xs text-rcrm-error">{meta.error}</div>
			) : null}
		</label>
	);
};

export default DatePicker;
